const supportedFileExtensions = {
    image: ["jpg","jpeg","png","gif"],
    audio: ["aaf", "3gp", "mp3"],
    video: ["avi", "dat", "flv", "m1v", "m2v", "m4v", "mov", "mpeg", "mpg", "mpe", "rm", "wmv", "mp4"],
    file: ["ppt", "pptx", "doc", "docx", "xls", "xlsx", "pdf"]
};

export default supportedFileExtensions;